/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { QuestionModel } from '../../models/question-model';

export interface QuestionnaireInstanceStartPostParams {
  questionnaireInstanceGuid: string;
}

export function questionnaireInstanceStartPost(http: HttpClient, rootUrl: string, params: QuestionnaireInstanceStartPostParams, context?: HttpContext): Observable<StrictHttpResponse<QuestionModel>> {
  const rb = new RequestBuilder(rootUrl, questionnaireInstanceStartPost.PATH, 'post');
  if (params) {
    rb.path('questionnaireInstanceGuid', params.questionnaireInstanceGuid, {"style":"simple"});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<QuestionModel>;
    })
  );
}

questionnaireInstanceStartPost.PATH = '/api/v1/questionnaire-instances/{questionnaireInstanceGuid}/start';
